import { IFluxStandardAction } from "@common";
import { AuthorizationType, IUser } from "@common/models";
import {
  IUpdateUserAuthorizationsRequest,
  ICreateUserApiKeyRequest,
  IDeleteUserApiKeyRequest,
  IUpdateUserApiKeyRequest,
  IUserDevice,
  IUserListRequset,
  IUserListResponse
} from "./admin.models";

export enum AdminActions {
  GET_USERS_RESPONSE = "@admin/user-list/response",
  GET_USERS = "@admin/user-list/request",
  USER_UPDATE_RESPNOSE = "@admin/user/updated",
  UPDATE_USER_AUTHORIZATIONS = "@admin/user/authorizations/update",
  UPDATE_USER_API_KEY = "@admin/user/api-key/update",
  CREATE_USER_API_KEY = "@admin/user/api-key/create",
  DELETE_USER_API_KEY = "@admin/user/api-key/delete",
  REMOVE_USER_DEVICE = "@admin/user/device/delete",
  APPROVE_USER_DEVICE = "@admin/user/device/approve"
}

export interface IRemoveDevice extends IFluxStandardAction<IUserDevice> {
  type: AdminActions.REMOVE_USER_DEVICE;
}

export interface IApproveDevice extends IFluxStandardAction<IUserDevice> {
  type: AdminActions.APPROVE_USER_DEVICE;
}

export interface IGetUsers extends IFluxStandardAction<IUserListRequset> {
  type: AdminActions.GET_USERS;
}

export interface ICreateUserApiKey
  extends IFluxStandardAction<ICreateUserApiKeyRequest> {
  type: AdminActions.CREATE_USER_API_KEY;
}

export interface IAdminUserUpdateResponse extends IFluxStandardAction<IUser> {
  type: AdminActions.USER_UPDATE_RESPNOSE;
}

export interface IDeleteUserApiKey
  extends IFluxStandardAction<IDeleteUserApiKeyRequest> {
  type: AdminActions.DELETE_USER_API_KEY;
}

export interface IUpdateUserApiKey
  extends IFluxStandardAction<IUpdateUserApiKeyRequest> {
  type: AdminActions.UPDATE_USER_API_KEY;
}

export interface IUpdateUserAuthorizations
  extends IFluxStandardAction<IUpdateUserAuthorizationsRequest> {
  type: AdminActions.UPDATE_USER_AUTHORIZATIONS;
}

export interface IGetUsersResponse
  extends IFluxStandardAction<IUserListResponse> {
  type: AdminActions.GET_USERS_RESPONSE;
}

export type AdminActionTypes =
  | IGetUsers
  | IGetUsersResponse
  | IAdminUserUpdateResponse;

export function removeDevice(userId: string, deviceId: string): IRemoveDevice {
  return {
    type: AdminActions.REMOVE_USER_DEVICE,
    payload: { userId, deviceId }
  };
}

export function approveDevice(
  userId: string,
  deviceId: string
): IApproveDevice {
  return {
    type: AdminActions.APPROVE_USER_DEVICE,
    payload: { userId, deviceId }
  };
}

export function createUserApiKey(userId: string): ICreateUserApiKey {
  return {
    type: AdminActions.CREATE_USER_API_KEY,
    payload: { userId }
  };
}

export function adminUserUpdateResponse(
  payload: IUser | Error,
  feedback: string = null
): IAdminUserUpdateResponse {
  return {
    type: AdminActions.USER_UPDATE_RESPNOSE,
    payload,
    meta: { feedback }
  };
}

export function updateUserApiKey(
  userId: string,
  newDate: string,
  newName: string,
  oldName: string
): IUpdateUserApiKey {
  return {
    type: AdminActions.UPDATE_USER_API_KEY,
    payload: { userId, newDate, newName, oldName }
  };
}

export function deleteUserApiKey(
  userId: string,
  tokenName: string
): IDeleteUserApiKey {
  return {
    type: AdminActions.DELETE_USER_API_KEY,
    payload: { userId, tokenName }
  };
}

export function updateUserAuthorizations(
  userId: string,
  claims: AuthorizationType[]
): IUpdateUserAuthorizations {
  return {
    type: AdminActions.UPDATE_USER_AUTHORIZATIONS,
    payload: { userId, claims }
  };
}

export function getUsers(
  skip?: number,
  searchText?: string,
  activeOnly?: boolean,
  sort?: string,
  reverseOrder?: boolean
): IGetUsers {
  return {
    type: AdminActions.GET_USERS,
    payload: {
      skip,
      searchText,
      activeOnly,
      sort,
      reverseOrder
    }
  };
}

export function getUsersResponse(
  payload,
  feedback: string = null
): IGetUsersResponse {
  return { type: AdminActions.GET_USERS_RESPONSE, payload, meta: { feedback } };
}
